import { render } from "./terms-and-condtion.vue?vue&type=template&id=1fc5348a"
import script from "./terms-and-condtion.vue?vue&type=script&lang=js"
export * from "./terms-and-condtion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__